import { getOrganizationSuggestions } from '@/api/generated/general-organizations/general-organizations';
import type { ListRequest, OrganizationSuggestion } from '@/api/generated/schemas';
import { createAsyncSelectorField } from '@/shared/forms';
import {
  defineEntityAsyncSelector,
  listRequestQueryKey,
  toListRequest,
  type NoPickFilters,
} from '@/shared/ui/async-selector';

/** UI ref organizace — identitou je stabilní `Party.ID`. */
export interface OrganizationRef {
  partyId: number;
  name: string;
}

const organizationSelector = defineEntityAsyncSelector<
  OrganizationRef,
  OrganizationSuggestion,
  ListRequest,
  NoPickFilters
>({
  api: {
    fetch: getOrganizationSuggestions,
    buildApiParams: (ctx) => toListRequest(ctx.search, ctx.ids),
    queryKey: (request) => listRequestQueryKey('general.organizations', request),
    mapItem: (dto) => ({ partyId: dto.partyId, name: dto.name }),
  },
  key: (item) => item.partyId,
  display: {
    kind: 'nameCode',
    name: (item) => item.name,
  },
  columns: (t) => [
    {
      id: 'name',
      header: t('organizationSelector.cols.name'),
      sortable: true,
      cell: (item: OrganizationRef) => item.name,
      flex: '1',
    },
  ],
  i18n: { namespace: 'general' },
});

export const OrganizationSelector = organizationSelector.Selector;
export const OrganizationSelectorField = createAsyncSelectorField(OrganizationSelector);
